/* NA LEIBERL – "Sortieren nach" als eigenes Dropdown im Shop-Branding
   (ersetzt optisch das Standard-Browser-Dropdown; das echte <select> bleibt fuer das Theme erhalten).
   Gilt fuer die Sortierung oben (Desktop) und in der Filter-Seitenleiste (Handy).
   Hinweis: Der Ausloeser ist bewusst kein <button>, weil die Filter-Seitenleiste des Themes
   jeden <button> darin als "Schliessen" behandelt. */
(function () {
  var SELECTOR = 'select.facet-filters__sort, .mobile-facets__sort select';
  var CHEVRON = '<svg viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK = '<svg viewBox="0 0 12 10" aria-hidden="true" focusable="false"><path d="M1 5.5l3.2 3L11 1.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var uid = 0;

  function label(opt) {
    var t = opt ? opt.textContent.trim() : '';
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function enhance(select) {
    if (select.dataset.nlSort) return;
    select.dataset.nlSort = '1';
    var holder = select.closest('.select') || select.parentNode;
    holder.classList.add('nl-sort-host');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    var id = 'nl-sort-' + (++uid);

    var wrap = document.createElement('div');
    wrap.className = 'nl-sort';
    var btn = document.createElement('div');
    btn.className = 'nl-sort__btn';
    btn.setAttribute('role', 'button');
    btn.tabIndex = 0;
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    if (select.id) {
      var lbl = document.querySelector('label[for="' + select.id + '"]');
      if (lbl) btn.setAttribute('aria-label', lbl.textContent.trim());
    }
    btn.innerHTML = '<span class="nl-sort__value"></span><span class="nl-sort__chev">' + CHEVRON + '</span>';
    var list = document.createElement('ul');
    list.className = 'nl-sort__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    Array.prototype.forEach.call(select.options, function (opt) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.dataset.value = opt.value;
      var span = document.createElement('span');
      span.textContent = label(opt);
      li.appendChild(span);
      li.insertAdjacentHTML('beforeend', '<span class="nl-sort__check">' + CHECK + '</span>');
      list.appendChild(li);
    });

    function sync() {
      wrap.querySelector('.nl-sort__value').textContent = label(select.options[select.selectedIndex]);
      Array.prototype.forEach.call(list.children, function (li) {
        var on = li.dataset.value === select.value;
        li.setAttribute('aria-selected', on ? 'true' : 'false');
        li.classList.toggle('is-selected', on);
      });
    }
    function open() {
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      var sel = list.querySelector('.is-selected') || list.firstChild;
      if (sel) sel.focus();
    }
    function close(focusBtn) {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
      if (focusBtn) btn.focus();
    }
    function choose(value) {
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
      close(true);
    }

    btn.addEventListener('click', function (e) { e.preventDefault(); list.hidden ? open() : close(); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') { e.preventDefault(); open(); }
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('li[role=option]');
      if (li) choose(li.dataset.value);
    });
    list.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(list.children);
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (items[i]) choose(items[i].dataset.value); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); }
      else if (e.key === 'Tab') { close(false); }
    });
    // Escape im offenen Dropdown soll nicht gleich die ganze Filter-Seitenleiste schliessen
    wrap.addEventListener('keyup', function (e) { if (e.key === 'Escape') e.stopPropagation(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    select.addEventListener('change', sync);

    wrap.appendChild(btn);
    wrap.appendChild(list);
    holder.appendChild(wrap);
    sync();
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), enhance);
  }
  var scheduled = false;
  function init() {
    run();
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; run(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
